(function (window, document) {
  'use strict';

  var FORM_SELECTOR = '[data-gc-inquiry-form]';

  function getForms() {
    return Array.prototype.slice.call(document.querySelectorAll(FORM_SELECTOR));
  }

  function getProducts() {
    if (window.GCInquiry && typeof window.GCInquiry.getInquiryList === 'function') {
      return window.GCInquiry.getInquiryList();
    }
    return [];
  }

  var STATE_CONFIG = {
    empty: {
      canSubmit: false,
      hintText: 'Ihr Anfragekorb ist leer.'
    },
    missing_qty: {
      canSubmit: false,
      hintText: 'Bitte Stückzahlen ergänzen.'
    },
    all_below: {
      canSubmit: false,
      hintText: 'Für kleinere Bestellungen nutzen Sie bitte den Online-Shop.'
    },
    has_bulk: {
      canSubmit: true,
      hintText: 'Sie erhalten ein individuelles Angebot. Wir melden uns innerhalb von 24 Stunden.'
    }
  };

  /**
   * Get current inquiry state from the API.
   * @returns {'empty'|'missing_qty'|'all_below'|'has_bulk'}
   */
  function getState() {
    if (window.GCInquiry && typeof window.GCInquiry.getInquiryState === 'function') {
      return window.GCInquiry.getInquiryState();
    }
    return 'empty';
  }

  /**
   * Ensure a hint element exists above the submit button.
   * @param {HTMLFormElement} form
   * @returns {HTMLElement}
   */
  function ensureHint(form) {
    var hint = form.querySelector('.gc-inquiry-form__min-hint');
    if (!hint) {
      hint = document.createElement('p');
      hint.className = 'gc-inquiry-form__min-hint';
      var actionsEl = form.querySelector('.gc-inquiry-form__actions');
      if (actionsEl) {
        actionsEl.parentNode.insertBefore(hint, actionsEl);
      }
    }
    return hint;
  }

  /**
   * Update button and hint based on the current inquiry state.
   */
  function updateFormState(form) {
    var submitBtn = form.querySelector('.gc-inquiry-form__submit');
    if (!submitBtn) {
      return;
    }

    var state = getState();
    var config = STATE_CONFIG[state] || STATE_CONFIG.empty;

    submitBtn.disabled = !config.canSubmit;

    var hint = ensureHint(form);
    hint.textContent = config.hintText;
    hint.className = 'gc-inquiry-form__min-hint';
    if (state === 'has_bulk') {
      hint.classList.add('gc-inquiry-form__min-hint--success');
    } else if (state === 'all_below') {
      hint.classList.add('gc-inquiry-form__min-hint--warning');
    } else if (state === 'missing_qty' || state === 'empty') {
      hint.classList.add('gc-inquiry-form__min-hint--info');
    }
  }

  function setMessage(form, text, isError) {
    var messageEl = form.querySelector('.gc-inquiry-form__message');
    if (!messageEl) {
      return;
    }
    messageEl.textContent = text || '';
    messageEl.classList.toggle('gc-inquiry-form__message--error', !!isError);
    messageEl.classList.toggle('gc-inquiry-form__message--success', !isError && !!text);
  }

  function disableForm(form, disabled) {
    var inputs = form.querySelectorAll('input, textarea, button');
    for (var i = 0; i < inputs.length; i++) {
      inputs[i].disabled = !!disabled;
    }
  }

  function handleSubmit(form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();

      // Guard: block submission when state does not allow it
      var state = getState();
      if (state !== 'has_bulk') {
        updateFormState(form);
        return;
      }

      var ajaxUrl = form.getAttribute('data-ajax-url');
      if (!ajaxUrl) {
        return;
      }

      setMessage(form, '');

      var formData = new FormData(form);
      formData.append('products', JSON.stringify(getProducts()));

      // Disable after collecting data to avoid disabled inputs being dropped
      disableForm(form, true);

      fetch(ajaxUrl, {
        method: 'POST',
        body: formData,
        credentials: 'same-origin',
      })
        .then(function (response) {
          if (!response.ok) {
            throw response;
          }
          return response.json();
        })
        .then(function (data) {
          if (data && data.success) {
            var successMessage = form.getAttribute('data-success-message') || '';
            setMessage(form, successMessage, false);
            form.classList.add('gc-inquiry-form--submitted');
          } else {
            var msg = data && data.data && data.data.message ? data.data.message : 'Fehler';
            setMessage(form, msg, true);
          }
        })
        .catch(function (err) {
          if (err && typeof err.json === 'function') {
            err.json().then(function (data) {
              var msg = data && data.data && data.data.message ? data.data.message : 'Fehler';
              setMessage(form, msg, true);
            });
          } else {
            setMessage(form, 'Es ist ein Fehler aufgetreten.', true);
          }
        })
        .finally(function () {
          disableForm(form, false);
        });
    });
  }

  function init() {
    var forms = getForms();
    forms.forEach(function (form) {
      handleSubmit(form);
      updateFormState(form);
    });

    // Keep form state in sync with inquiry list changes
    window.addEventListener('inquiryListChanged', function () {
      getForms().forEach(updateFormState);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})(window, document);
